var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"d-block w-100",attrs:{"src":_vm.resolveSrc(),"alt":_vm.title}}),(_vm.hasTitle)?_c('p',{staticClass:"text-center pt-2"},[_vm._v(_vm._s(_vm.title))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }